import { SalvNumberField, SalvTextArea, Size } from '@salvapp/ui-components';
import React from 'react';
import { useFormikContext } from 'formik';
import { RiskRuleVersionModalFormValues } from './RiskRuleVersionModal';
import './RiskRuleVersionLeftPanel.scss';

interface RiskRuleVersionLeftPanelProps {
  isDisabled: boolean;
}
const RiskRuleVersionLeftPanel = ({ isDisabled }: RiskRuleVersionLeftPanelProps) => {
  const { setFieldValue, values, errors } = useFormikContext<RiskRuleVersionModalFormValues>();

  return (
    <div className='risk-rule-version-left-panel'>
      <SalvNumberField
        label='Weight'
        description='Weight with which the risk rule score will be applied'
        placeholder='Weight'
        size={Size.MEDIUM}
        onChange={(weight) => setFieldValue('weight', weight)}
        value={values.weight}
        isInvalid={!!errors.weight}
        required={true}
        disabled={isDisabled}
        minValue={0}
      />
      <SalvTextArea
        label='Note'
        description='Comment on what is changing in this version'
        placeholder='Note'
        size={Size.MEDIUM}
        onChange={(note) => setFieldValue('note', note)}
        value={values.note}
        autoSizing={true}
        minRows={4}
        isInvalid={!!errors.note}
        required={true}
        className='note-field'
        disabled={isDisabled}
      />
    </div>
  );
};

export default RiskRuleVersionLeftPanel;
